function gameFuncs() {}

const createResource = (
  name,
  symbol,
  startingAmount = 0,
  startingProduction = 0,
  minMod = 0
) => {
  return {
    name,
    symbol,
    minMod,
    amount: startingAmount,
    production: startingProduction,
  };
};

gameFuncs.createGameState = (corporation) => {
  return {
    corporation: corporation,
    terraformRating: 20,
    money: createResource(
      'Mega Credits',
      '💶',
      corporation.money,
      corporation.moneyProduction,
      -5
    ),
    steel: createResource(
      'Steel',
      '🏗',
      corporation.steel,
      corporation.steelProduction
    ),
    titanium: createResource(
      'Titanium',
      '🌠',
      corporation.titanium,
      corporation.titaniumProduction
    ),
    plants: createResource(
      'Plants',
      '🌱',
      corporation.plants,
      corporation.plantsProduction
    ),
    energy: createResource(
      'Energy',
      '🔋',
      corporation.energy,
      corporation.energyProduction
    ),
    heat: createResource(
      'Heat',
      '🌡',
      corporation.heat,
      corporation.heatProduction
    ),
    cart: {
      money: 0,
      steel: 0,
      titanium: 0,
      heat: 0,
    },
  };
};

gameFuncs.adjustResource = (gameState, resourceName, delta) => {
  const newGameState = { ...gameState };
  const newResource = { ...gameState[resourceName] };
  const newValue = newResource.amount + delta;

  newResource.amount = Math.max(newValue, 0);
  newGameState[resourceName] = newResource;

  return newGameState;
};

gameFuncs.adjustProduction = (gameState, resourceName, delta) => {
  const newGameState = { ...gameState };
  const resource = { ...gameState[resourceName] };
  const newProduction = resource.production + delta;

  resource.production = Math.max(newProduction, resource.minMod);
  newGameState[resourceName] = resource;

  return newGameState;
};

gameFuncs.resourcePhase = (gameState) => {
  const money = { ...gameState.money };
  const steel = { ...gameState.steel };
  const titanium = { ...gameState.titanium };
  const plants = { ...gameState.plants };
  const heat = { ...gameState.heat };
  const energy = { ...gameState.energy };

  money.amount += money.production + gameState.terraformRating;
  steel.amount += steel.production;
  titanium.amount += titanium.production;
  plants.amount += plants.production;
  heat.amount += energy.amount + heat.production;
  energy.amount = energy.production;

  return { ...gameState, money, steel, titanium, plants, heat, energy };
};

gameFuncs.adjustTerraformRating = (gameState, delta) => {
  const newGameState = { ...gameState };
  const terraformRating = gameState.terraformRating + delta;

  newGameState.terraformRating = Math.max(terraformRating, 0);

  return newGameState;
};

// TODO:
gameFuncs.adjustCart = (gameState, resourceName, delta) => {
  const newGameState = { ...gameState };
  const cart = { ...gameState.cart };

  // TODO: check for zeros
  const newValue = Math.max(0, cart[resourceName] + delta);
  cart[resourceName] = newValue;
  newGameState[resourceName].amount -= delta;

  return newGameState;
};

// TODO:
gameFuncs.cancelCart = (gameState) => {
  const newGameState = { ...gameState };
  newGameState.cart = {
    money: 0,
    steel: 0,
    titanium: 0,
    heat: 0,
  };

  return newGameState;
};

gameFuncs.purchase = (gameState, deductions) => {
  //
  const newGameState = { ...gameState };
  newGameState.cart = {
    money: 0,
    steel: 0,
    titanium: 0,
    heat: 0,
  };

  for (const resource in deductions) {
    const amount = deductions[resource];
    newGameState[resource].amount -= amount;
  }

  return newGameState;
};

export default gameFuncs;
